import { Breakpoints, useBreakpoint } from '@src/hooks/useBreakpoint'
import { DatoCmsFileField } from '@src/typings/dato-cms-assets'
import type { ReactNode } from 'react'
import { NcImage } from '../nc-image/NcImage.component'
import styles from './InTheApp.module.scss'

export interface InTheAppProps {
  sectionHeading: string
  appInfoSections: {
    image: DatoCmsFileField
    helperImage: DatoCmsFileField
    title: string
    paragraph: string
  }[]
}

export function InTheApp({ sectionHeading, appInfoSections }: InTheAppProps): ReactNode {
  const isMobile = useBreakpoint().width < Breakpoints.bpMedium

  return (
    <section className={styles.InTheApp}>
      <h3 className={styles.InTheApp__heading}>{sectionHeading}</h3>
      <div className={styles.InTheApp__content}>
        {appInfoSections.map((section, i) => (
          <div key={section.title} className={styles.InTheApp__section}>
            <NcImage
              className={styles.InTheApp__image}
              // just the first image on the first block has a different image for mobile
              {...(isMobile && section.helperImage ? section.helperImage : section.image)}
              alt={i === 0 && isMobile ? section.helperImage.alt : section.image.alt}
            />
            <h3 className={styles.InTheApp__groupHeading}>{section.title}</h3>
            <p className={styles.InTheApp__groupParagraph}>{section.paragraph}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
